import { HeaderStructure, NavigationStructure, SEPARATOR, SupportedHeaderLanguage } from './types';
import { convertToNavigationItem, isNavigationItemSupportCurrentLanguage, isSupportedLanguage } from './utils';

export const supportedHeaderLanguages = [
  'en',
  'pt',
  'fr',
  'de',
  'es',
  'ja',
  'ru',
  'it',
  'nl',
  'tr',
  'ko',
  'pl',
  'cs',
  'da',
  'no',
  'sv',
  'th',
  'zh',
  'uk',
] as const;

const headerStructure: HeaderStructure = [
  {
    text: 'menu_creation',
    name: 'creation',
    subs: [
      {
        text: 'sub_menu_creation_platform',
        name: 'creation_platform',
        subs: [
          {
            text: 'sub_sub_menu_website_design',
            description: 'description_website_design',
            href: {
              en: 'https://www.wix.com/website/design',
              es: 'https://es.wix.com/diseno/web',
              pt: 'https://pt.wix.com/website/design',
              fr: 'https://fr.wix.com/website/design',
              de: 'https://de.wix.com/website/design',
            },
            name: 'website_design',
          },
          {
            text: 'sub_sub_menu_website_templates',
            description: 'description_website_templates',
            name: 'website_templates',
            href: {
              en: 'https://www.wix.com/website/templates',
              es: 'https://es.wix.com/website/templates',
              pt: 'https://pt.wix.com/website/templates',
              fr: 'https://fr.wix.com/website/templates',
              de: 'https://de.wix.com/website/templates',
            },
          },
          {
            text: 'sub_sub_menu_advanced_web_development',
            description: 'description_advanced_web_development',
            href: 'https://www.wix.com/velo',
            name: 'advanced_web_development',
            target: '_blank',
          },
          {
            text: 'sub_sub_menu_blog',
            description: 'description_blog',
            name: 'blog',
            href: {
              en: 'https://www.wix.com/start/blog',
              es: 'https://es.wix.com/start/crear-blog',
              pt: 'https://pt.wix.com/start/criar-blog',
              fr: 'https://fr.wix.com/start/creer-blog',
              de: 'https://de.wix.com/start/blog-erstellen',
            },
          },
          {
            text: 'sub_sub_menu_portfolio_website',
            description: 'description_portfolio_website',
            href: {
              en: 'https://www.wix.com/portfolio-website',
              es: 'https://es.wix.com/portafolio-digital',
              pt: 'https://pt.wix.com/portfolio-online',
              fr: 'https://fr.wix.com/portfolio-en-ligne',
              de: 'https://de.wix.com/portfolio-website',
            },
            name: 'portfolio_website',
          },
          {
            text: 'sub_sub_menu_logo_maker',
            description: 'description_logo_maker',
            href: {
              en: 'https://www.wix.com/logo/maker',
              es: 'https://es.wix.com/logo/maker',
              pt: 'https://pt.wix.com/logo/criar-logo',
              fr: 'https://fr.wix.com/logo/creer-logo',
              de: 'https://de.wix.com/logo/erstellen',
            },
            name: 'logo_maker',
            target: '_blank',
          },
        ],
      },
      {
        text: 'sub_menu_website_essentials',
        name: 'website_essentials',
        subs: [
          {
            text: 'sub_sub_menu_domain_name',
            description: 'description_domain_name',
            name: 'custom_domain_name',
            href: {
              en: 'https://www.wix.com/domain/names',
              es: 'https://es.wix.com/dominio/gratis',
              pt: 'https://pt.wix.com/dominio/gratis',
              fr: 'https://fr.wix.com/nom-de-domaine/gratuit',
              de: 'https://de.wix.com/domain/check',
            },
          },
          {
            text: 'sub_sub_menu_seo_tools',
            description: 'description_seo_tools',
            name: 'seo_tools',
            href: {
              en: 'https://www.wix.com/seo',
              es: 'https://es.wix.com/features/wix-seo',
              pt: 'https://pt.wix.com/features/wix-seo',
              fr: 'https://fr.wix.com/features/wix-seo',
              de: 'https://de.wix.com/features/wix-seo',
            },
          },
          {
            text: 'sub_sub_menu_website_security',
            description: 'description_website_security',
            href: {
              en: 'https://www.wix.com/website-security',
              es: 'https://es.wix.com/website-security',
              pt: 'https://pt.wix.com/website-security',
              fr: 'https://fr.wix.com/website-security',
              de: 'https://de.wix.com/website-security',
            },
            name: 'website_security',
          },
          {
            text: 'sub_sub_menu_free_web_hosting',
            description: 'description_free_web_hosting',
            name: 'free_web_hosting',
            href: {
              en: 'https://www.wix.com/free/web-hosting',
              es: 'https://es.wix.com/hosting/gratis',
              pt: 'https://pt.wix.com/hospedagem-de-site/gratis',
              fr: 'https://fr.wix.com/hebergement/gratuit',
              de: 'https://de.wix.com/hosting',
            },
          },
          {
            text: 'sub_sub_menu_roles_and_permissions',
            description: 'description_roles_and_permissions',
            href: {
              en: 'https://www.wix.com/manage/roles-and-permissions',
              es: 'https://es.wix.com/manage/roles-and-permissions',
              pt: 'https://pt.wix.com/manage/roles-and-permissions',
              fr: 'https://fr.wix.com/manage/roles-and-permissions',
              de: 'https://de.wix.com/manage/roles-and-permissions',
            },
            name: 'roles_and_permissions',
          },
          {
            text: 'sub_sub_menu_multilingual_website',
            description: 'description_multilingual_website',
            name: 'multilingual_website',
            href: {
              en: 'https://www.wix.com/localization/multilingual',
              es: 'https://es.wix.com/multilingual/localization',
              pt: 'https://pt.wix.com/multilingual/localization',
              fr: 'https://fr.wix.com/multilingual/localization',
              de: 'https://de.wix.com/multilingual/localization',
            },
          },
          {
            text: 'sub_sub_menu_mobile_app',
            description: 'description_mobile_app',
            name: 'sub_sub_menu_mobile_app',
            href: {
              en: 'https://www.wix.com/mobile/wix-app',
              es: 'https://es.wix.com/mobile/wix-app',
              pt: 'https://pt.wix.com/mobile/wix-app',
              fr: 'https://fr.wix.com/mobile/wix-app',
              de: 'https://de.wix.com/mobile/wix-app',
            },
          },
          {
            text: 'sub_sub_menu_analytics',
            description: 'description_analytics',
            href: {
              en: 'https://www.wix.com/manage/analytics',
              es: 'https://es.wix.com/manage/analisis-web',
              pt: 'https://pt.wix.com/manage/web-analytics',
              fr: 'https://fr.wix.com/manage/analytics',
              de: 'https://de.wix.com/manage/analytics',
            },
            name: 'analytics',
          },
        ],
      },
      {
        text: 'sub_menu_wix_for_enterprise',
        href: 'https://www.wix.com/enterprise',
        name: 'wix_for_enterprise',
        lang: ['en'],
      },
      {
        text: 'sub_menu_hire_a_partner',
        name: 'hire_a_partner',
        target: '_blank',
        href: {
          en: 'https://www.wix.com/marketplace',
          es: 'https://es.wix.com/marketplace',
          pt: 'https://pt.wix.com/marketplace',
          fr: 'https://fr.wix.com/marketplace',
          de: 'https://de.wix.com/marketplace',
        },
      },
    ],
  },
  {
    text: 'menu_business',
    name: 'business',
    subs: [
      {
        text: 'sub_menu_ecommerce_platform',
        name: 'ecommerce_platform',
        subs: [
          {
            text: 'sub_sub_menu_online_store',
            description: 'description_online_store',
            name: 'online_store',
            target: '_blank',
            href: {
              en: 'https://www.wix.com/ecommerce/website',
              es: 'https://es.wix.com/ecommerce/tienda-online',
              pt: 'https://pt.wix.com/ecommerce/loja-virtual',
              fr: 'https://fr.wix.com/ecommerce/site-vente-en-ligne',
              de: 'https://de.wix.com/ecommerce/onlineshop-erstellen',
            },
          },
          {
            text: 'sub_sub_menu_orders_and_fulfillment',
            description: 'description_orders_and_fulfillment',
            name: 'orders_and_fulfillment',
            target: '_blank',
            href: {
              en: 'https://www.wix.com/ecommerce/manage',
              es: 'https://es.wix.com/ecommerce/manage',
              pt: 'https://pt.wix.com/ecommerce/manage',
              fr: 'https://fr.wix.com/ecommerce/manage',
              de: 'https://de.wix.com/ecommerce/manage',
            },
          },
          {
            text: 'sub_sub_menu_dropshipping',
            description: 'description_dropshipping',
            href: 'https://www.wix.com/ecommerce/dropshipping',
            name: 'dropshipping',
            target: '_blank',
            lang: ['en'],
          },
          {
            text: 'sub_sub_menu_services_and_memberships',
            description: 'description_services_and_memberships',
            href: {
              en: 'https://www.wix.com/scheduling-software',
              es: 'https://es.wix.com/agendador-de-citas',
              pt: 'https://pt.wix.com/sistema-de-agendamento',
              fr: 'https://fr.wix.com/reservation-en-ligne',
              de: 'https://de.wix.com/online-buchungssystem',
            },
            name: 'services_and_memberships',
            target: '_blank',
          },
          {
            text: 'sub_sub_menu_online_payments',
            description: 'description_online_payments',
            href: {
              en: 'https://www.wix.com/payments',
              es: 'https://es.wix.com/payments/payment-gateways',
              pt: 'https://pt.wix.com/pagamentos',
              fr: 'https://fr.wix.com/payments/payment-gateways',
              de: 'https://de.wix.com/payments',
            },
            name: 'online_payments',
            target: '_blank',
          },
          {
            text: 'sub_sub_menu_multichannel_sales',
            description: 'description_multichannel_sales',
            href: {
              en: 'https://www.wix.com/ecommerce/sell',
              es: 'https://es.wix.com/ecommerce/sell',
              pt: 'https://pt.wix.com/ecommerce/sell',
              fr: 'https://fr.wix.com/ecommerce/sell',
              de: 'https://de.wix.com/ecommerce/sell',
            },
            name: 'multichannel_sales',
            target: '_blank',
          },
          {
            text: 'sub_sub_menu_point_of_sale',
            description: 'description_point_of_sale',
            href: 'https://www.wix.com/pos',
            name: 'point_of_sale',
            target: '_blank',
            lang: ['en'],
          },
        ],
      },
      {
        text: 'sub_menu_solutions_by_industry',
        name: 'solutions_by_industry',
        subs: [
          {
            text: 'sub_sub_menu_restaurants',
            description: 'description_restaurants',
            name: 'restaurants',
            href: {
              en: 'https://www.wix.com/restaurant/website',
              es: 'https://es.wix.com/restaurant/website',
              pt: 'https://pt.wix.com/restaurant/website',
              fr: 'https://fr.wix.com/restaurant/website',
              de: 'https://de.wix.com/restaurant/website',
            },
          },
          {
            text: 'sub_sub_menu_hotels',
            description: 'description_hotels',
            name: 'hotels',
            href: {
              en: 'https://www.wix.com/hotels/website',
              es: 'https://es.wix.com/hotels/website',
              pt: 'https://pt.wix.com/hotels/website',
              fr: 'https://fr.wix.com/hotels/website',
              de: 'https://de.wix.com/hotels/website',
            },
          },
          {
            text: 'sub_sub_menu_photography',
            description: 'description_photography',
            name: 'photography',
            target: '_blank',
            href: {
              en: 'https://www.wix.com/photography/website',
              es: 'https://es.wix.com/photography/website',
              pt: 'https://pt.wix.com/criar/site-de-fotografia',
              fr: 'https://fr.wix.com/photography/website',
              de: 'https://de.wix.com/photography/website',
            },
          },
          {
            text: 'sub_sub_menu_events',
            description: 'description_events',
            name: 'events',
            target: '_blank',
            href: {
              en: 'https://www.wix.com/event/website',
              es: 'https://es.wix.com/event/website',
              pt: 'https://pt.wix.com/event/website',
              fr: 'https://fr.wix.com/event/website',
              de: 'https://de.wix.com/event/website',
            },
          },
          {
            text: 'sub_sub_menu_music',
            description: 'description_music',
            name: 'music',
            href: {
              en: 'https://www.wix.com/music/website',
              es: 'https://es.wix.com/music/website',
              pt: 'https://pt.wix.com/music/website',
              fr: 'https://fr.wix.com/music/website',
              de: 'https://de.wix.com/music/website',
            },
          },
        ],
      },
      {
        text: 'sub_menu_business_tools',
        name: 'business_tools',
        subs: [
          {
            text: 'sub_sub_menu_online_scheduling',
            description: 'description_online_scheduling',
            href: {
              en: 'https://www.wix.com/scheduling-software',
              es: 'https://es.wix.com/agendador-de-citas',
              pt: 'https://pt.wix.com/sistema-de-agendamento',
              fr: 'https://fr.wix.com/reservation-en-ligne',
              de: 'https://de.wix.com/online-buchungssystem',
            },
            name: 'online_scheduling',
            target: '_blank',
          },
          {
            text: 'sub_sub_menu_business_email',
            description: 'description_business_email',
            name: 'business_email',
            href: {
              en: 'https://www.wix.com/business/email-address',
              es: 'https://es.wix.com/profesional/correo-empresarial',
              pt: 'https://pt.wix.com/email/profissional',
              fr: 'https://fr.wix.com/adresse-email/professionnelle',
              de: 'https://de.wix.com/business/eigene-email-domain',
            },
          },
          {
            text: 'sub_sub_menu_business_phone_number',
            description: 'description_business_phone_number',
            href: 'https://www.wix.com/business-phone-number',
            name: 'business_phone_number',
            lang: ['en'],
          },
          {
            text: 'sub_sub_menu_ascend_business_solution',
            description: 'description_ascend_business_solution',
            name: 'ascend_business_solution',
            href: {
              en: 'https://www.wix.com/ascend/home',
              es: 'https://es.wix.com/ascend/home',
              pt: 'https://pt.wix.com/ascend/home',
              fr: 'https://fr.wix.com/ascend/home',
              de: 'https://de.wix.com/ascend/home',
            },
            lang: ['en'],
          },
          {
            text: 'sub_sub_menu_analytics_and_reports',
            description: 'description_analytics_and_reports',
            name: 'analytics_and_reports',
            href: {
              en: 'https://www.wix.com/manage/analytics',
              es: 'https://es.wix.com/manage/analisis-web',
              pt: 'https://pt.wix.com/manage/web-analytics',
              fr: 'https://fr.wix.com/manage/analytics',
              de: 'https://de.wix.com/manage/analytics',
            },
          },
        ],
      },
    ],
  },
  {
    text: 'menu_growth',
    name: 'growth',
    subs: [
      {
        text: 'sub_menu_boost_website_traffic',
        name: 'boost_website_traffic',
        subs: [
          {
            text: 'sub_sub_menu_email_marketing',
            description: 'description_email_marketing',
            href: {
              en: 'https://www.wix.com/ascend/email-marketing',
              es: 'https://es.wix.com/ascend/email-marketing',
              pt: 'https://pt.wix.com/ascend/email-marketing',
              fr: 'https://fr.wix.com/ascend/email-marketing',
              de: 'https://de.wix.com/ascend/email-marketing',
            },
            name: 'email_marketing',
            target: '_blank',
          },
          {
            text: 'sub_sub_menu_social_posts',
            description: 'description_social_posts',
            name: 'social_posts',
            href: {
              en: 'https://www.wix.com/ascend/social-media-graphics',
              es: 'https://es.wix.com/ascend/social-media-graphics',
              pt: 'https://pt.wix.com/ascend/arte-redes-sociais',
              fr: 'https://fr.wix.com/ascend/social-media-graphics',
              de: 'https://de.wix.com/ascend/social-media-grafiken',
            },
          },
          {
            text: 'sub_sub_menu_facebook_ads',
            description: 'description_facebook_ads',
            href: {
              en: 'https://www.wix.com/features/facebook-ads',
              es: 'https://es.wix.com/features/facebook-ads',
              pt: 'https://pt.wix.com/features/facebook-ads',
              fr: 'https://fr.wix.com/features/facebook-ads',
              de: 'https://de.wix.com/features/facebook-ads',
            },
            name: 'facebook_ads',
            target: '_blank',
          },
          {
            text: 'sub_sub_menu_video_maker',
            description: 'description_video_maker',
            name: 'video_maker',
            href: {
              en: 'https://www.wix.com/tools/video-maker',
              es: 'https://es.wix.com/tools/video-maker',
              pt: 'https://pt.wix.com/tools/video-maker',
              fr: 'https://fr.wix.com/tools/video-maker',
              de: 'https://de.wix.com/tools/video-maker',
            },
          },
        ],
      },
      {
        text: 'sub_menu_engage_your_clients',
        name: 'engage_your_clients',
        subs: [
          {
            text: 'sub_sub_menu_lead_capture_tools',
            description: 'description_lead_capture_tools',
            name: 'lead_capture_tools',
            href: {
              en: 'https://www.wix.com/ascend/lead-capture',
              es: 'https://es.wix.com/ascend/captar-clientes',
              pt: 'https://pt.wix.com/ascend/geracao-de-leads',
              fr: 'https://fr.wix.com/ascend/fideliser-ses-clients',
              de: 'https://de.wix.com/ascend/kunden-gewinnen',
            },
          },
          {
            text: 'sub_sub_menu_financial_tools',
            description: 'description_financial_tools',
            name: 'financial_tools',
            href: {
              en: 'https://www.wix.com/ascend/collect-payments',
              es: 'https://es.wix.com/ascend/collect-payments',
              pt: 'https://pt.wix.com/ascend/collect-payments',
              fr: 'https://fr.wix.com/ascend/collect-payments',
              de: 'https://de.wix.com/ascend/collect-payments',
            },
          },
          {
            text: 'sub_sub_menu_growth_mobile_app',
            description: 'description_growth_mobile_app',
            name: 'growth_mobile_app',
            href: {
              en: 'https://www.wix.com/mobile/wix-app',
              es: 'https://es.wix.com/mobile/wix-app',
              pt: 'https://pt.wix.com/mobile/wix-app',
              fr: 'https://fr.wix.com/mobile/wix-app',
              de: 'https://de.wix.com/mobile/wix-app',
            },
          },
          {
            text: 'sub_sub_menu_crm_by_ascend',
            description: 'description_crm_by_ascend',
            name: 'crm_by_ascend',
            href: {
              en: 'https://www.wix.com/ascend/crm',
              es: 'https://es.wix.com/ascend/crm',
              pt: 'https://pt.wix.com/ascend/crm',
              fr: 'https://fr.wix.com/ascend/crm',
              de: 'https://de.wix.com/ascend/crm',
            },
          },
          {
            text: 'sub_sub_menu_community_management',
            description: 'description_community_management',
            name: 'community_management',
            href: {
              en: 'https://www.wix.com/business/community',
              es: 'https://es.wix.com/business/comunidad-virtual',
              pt: 'https://pt.wix.com/business/community',
              fr: 'https://fr.wix.com/business/community',
              de: 'https://de.wix.com/business/community',
            },
          },
        ],
      },
      {
        text: 'sub_menu_hire_a_partner',
        href: {
          en: 'https://www.wix.com/marketplace',
          es: 'https://es.wix.com/marketplace',
          pt: 'https://pt.wix.com/marketplace',
          fr: 'https://fr.wix.com/marketplace',
          de: 'https://de.wix.com/marketplace',
        },
        name: 'growth_hire_a_partner',
        target: '_blank',
      },
    ],
  },
  {
    text: 'menu_resources',
    name: 'resources',
    subs: [
      {
        text: 'sub_menu_all_features',
        description: 'description_all_features',
        name: 'all_features',
        href: {
          en: 'https://www.wix.com/features/main',
          es: 'https://es.wix.com/features/main',
          pt: 'https://pt.wix.com/features/main',
          fr: 'https://fr.wix.com/features/main',
          de: 'https://de.wix.com/features/main',
        },
      },
      {
        text: 'sub_menu_web_design_inspiration',
        description: 'description_web_design_inspiration',
        name: 'web_design_inspiration',
        href: {
          en: 'https://www.wix.com/explore/websites',
          es: 'https://es.wix.com/explore/websites',
          pt: 'https://pt.wix.com/explore/websites',
          fr: 'https://fr.wix.com/explore/websites',
          de: 'https://de.wix.com/explore/websites',
        },
      },
      {
        text: 'sub_menu_wix_blog',
        description: 'description_wix_blog',
        name: 'wix_blog',
        target: '_blank',
        href: {
          en: 'https://www.wix.com/blog',
          es: 'https://es.wix.com/blog',
          pt: 'https://pt.wix.com/blog',
          fr: 'https://fr.wix.com/blog',
          de: 'https://de.wix.com/blog',
        },
      },
      {
        text: 'sub_menu_updates_and_releases',
        description: 'description_updates_and_releases',
        href: 'https://www.wix.com/release/notes',
        name: 'updates_and_releases',
        lang: ['en'],
      },
      {
        text: 'sub_menu_app_integrations',
        description: 'description_resources_app_integrations',
        name: 'resources_app_integrations',
        target: '_blank',
        href: {
          en: 'https://www.wix.com/app-market',
          es: 'https://es.wix.com/app-market',
          pt: 'https://pt.wix.com/app-market',
          fr: 'https://fr.wix.com/app-market',
          de: 'https://de.wix.com/app-market',
        },
      },
      {
        text: 'sub_menu_become_a_partner',
        description: 'description_become_a_partner',
        href: 'https://www.wix.com/partners',
        name: 'become_a_partner',
        target: '_blank',
      },
      {
        text: 'sub_menu_privacy_center',
        description: 'description_privacy_center',
        name: 'privacy_center',
        href: {
          en: 'https://www.wix.com/manage/privacy',
          es: 'https://es.wix.com/manage/privacy',
          pt: 'https://pt.wix.com/manage/privacy',
          fr: 'https://fr.wix.com/manage/privacy',
          de: 'https://de.wix.com/manage/privacy',
        },
      },
    ],
  },
  {
    text: 'menu_mobile_app',
    name: 'mobile_app',
    href: {
      en: 'https://www.wix.com/mobile/wix-app',
      es: 'https://es.wix.com/mobile/wix-app',
      pt: 'https://pt.wix.com/mobile/wix-app',
      fr: 'https://fr.wix.com/mobile/wix-app',
      de: 'https://de.wix.com/mobile/wix-app',
    },
    mobileOnly: true,
  },
  SEPARATOR,
  {
    text: 'menu_pricing',
    name: 'pricing',
    href: {
      en: 'https://www.wix.com/upgrade/website',
      es: 'https://es.wix.com/upgrade/website',
      pt: 'https://pt.wix.com/upgrade/website',
      fr: 'https://fr.wix.com/upgrade/website',
      de: 'https://de.wix.com/upgrade/website',
    },
  },
  {
    text: 'menu_support',
    name: 'support',
    href: {
      en: 'https://support.wix.com/en/',
      es: 'https://support.wix.com/es/',
      pt: 'https://support.wix.com/pt/',
      fr: 'https://support.wix.com/fr/',
      de: 'https://support.wix.com/de/',
    },
  },
];

export const getHeaderStructureByLanguage = (language: string): NavigationStructure | null => {
  if (!isSupportedLanguage(language)) {
    return null;
  }
  return headerStructure.reduce<NavigationStructure>((acc, item) => {
    if (item === SEPARATOR) {
      acc.push(item);
    } else {
      if (isNavigationItemSupportCurrentLanguage(item, language)) {
        acc.push(convertToNavigationItem(item, language));
      }
    }
    return acc;
  }, []);
};
